<template>
	<div class="main">
		<header class="page-title">
			<h2>{{title}}</h2>
			<div class="ml-auto">
				<a @click="showModal" class="btn btn-md btn-success" v-if="this.roles.includes('staticpage.create')"><i class="fas fa-plus"></i> New {{type}}</a>
			</div>
		</header>
		<div class="table-responsive">
			<table>
				<thead>
					<tr>
						<th>Name</th>
						<th>API slug</th>
						<th>URL slug</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(page,index) in pages">
						<td>{{page.name}}</td>
						<td>{{page.slug}}</td>
						<td>{{page.url_slug}}</td>
						<td class="nowrap">
							<a :href="getEditUrl(index)" class="btn btn-icon btn-primary" title="Manage"><i class="fas fa-pencil-alt"></i></a>
							<a @click="deletePage(page.id)" class="btn btn-icon btn-danger" title="Delete"><i class="fas fa-trash-alt"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<modal @close="closeModal" v-show="isNewModalVisible">
			<template slot="header">
				<h4 class="modal-title">Add New {{type}}</h4>
			</template>
			<template slot="body">
				<div class="form-group">
					<label>Name</label>
					<input type="text" v-model="newPage.name">
				</div>
				<div class="form-group">
					<label>API slug</label>
					<input disabled type="text" v-model="slug">
				</div>
				<div class="form-group">
					<label>Url slug</label>
					<input type="text" v-model="newPage.url_slug">
				</div>
			</template>
			<template slot="footer">
				<a @click="closeModal" class="btn btn-md btn-primary modal-close"><i class="fas fa-times"></i> Cancel</a>
				<a @click="addPage" class="btn btn-md btn-success"><i class="fas fa-save"></i> Add New Page</a>
			</template>
		</modal>

	</div>
</template>

<script>
	import modal from '../Modal/DefaultModal.vue';
	import VueSelect from 'vue-select';

	export default {
		props: {
			data: {
				type: Object
			},
		},
		components: {
			modal,
			"vue-select": VueSelect,
		},
		data() {
			return {
				title: '',
				type: '',
				pages: this.data.pages ? this.data.pages : {},
				isNewModalVisible: false,
				isItTool: false,
				newPage: {
					is_tool: false,
					name: '',
					fields: {},
					url_slug: '',
				},
				roles: this.data.roles,
				editUrl: window.location.protocol + '//' + window.location.hostname + window.location.pathname + '/',
			}
		},
		created() {
			this.getTitle();
		},
		mounted() {
		},
		computed: {
			slug: function () {
				return this.newPage.name.toLowerCase().replace(' ', '').replace(/[^0-9a-z]/gi, '');
			}
		},
		methods: {
			getEditUrl: function (index) {
				var finalEditUrl = this.isItTool ? this.editUrl + this.pages[index].slug : this.editUrl + this.pages[index].id;
				return finalEditUrl.replace('://', ':||').replace('//', '/').replace(':||', '://');
			},
			getTitle: function () {
				if (window.location.pathname.includes('staticpages')) {
					this.type = 'Static Page';
					this.title = 'Static Pages';

				} else {
					this.type = 'ToolsHub Item';
					this.title = 'ToolsHub';
					this.isItTool = true;
				}
			},
			showModal: function () {
				this.isNewModalVisible = true;
			},
			closeModal: function () {
				this.isNewModalVisible = false;
			},
			addPage: function (id) {
				let vm = this;

				axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/createpage',
					{
						slug: vm.slug,
						url_slug: vm.newPage.url_slug,
						name: vm.newPage.name,
						is_tool: vm.isItTool
					},
				).then(function (response) {
					vm.$toastr.success(vm.type + ' created successfully.');
					if (vm.isItTool) {
						var finalEditUrl = vm.editUrl + response.data.slug;
					} else {
						var finalEditUrl = vm.editUrl + response.data.id;
					}
					window.open(finalEditUrl.replace('://', ':||').replace('//', '/').replace(':||', '://'), '_self');
				}).catch(function (e) {
					vm.$toastr.error('Page create failed.', 'Error');
				});
			},
			deletePage: function (id) {
				let vm = this;

				vm.$dialog.confirm('Are you sure you want to delete this ' + vm.type + '?', {
					loader: true
				})
					.then((dialog) => {
						axios.post('/api/' + vm.$selectedSite.slug + '/staticpage/' + id + '/deletepage',
						).then(function (response) {
							vm.$toastr.success('Page deleted successfully.');
							window.location.reload();
						}).catch(function (e) {
							vm.$toastr.error('Page delete failed.', 'Error');
						});
					});
			},

		}
	}
</script>
